export type AlertNoticeUserLanguage = 'es' | 'en';

const ISO_YM = /^(\d{4})-(\d{2})(?:-(\d{2}))?$/;
const SLASH_MY = /^(\d{1,2})\/(\d{4})$/;
/** e.g. "July 2026", "julio 2026" */
const WORD_THEN_YEAR = /^(.+?)\s+(\d{4})$/;

function formatYearMonth(d: Date, lang: AlertNoticeUserLanguage): string {
  const locale = lang === 'es' ? 'es-ES' : 'en-US';
  return d.toLocaleDateString(locale, { month: 'long', year: 'numeric' });
}

/**
 * Normaliza el `period` que viene del backend (suele estar en inglés) al locale del usuario.
 */
export function formatAlertRentPeriod(
  period: string | null | undefined,
  lang: AlertNoticeUserLanguage,
): string {
  if (!period?.trim()) return '—';
  const trimmed = period.trim();

  const iso = trimmed.match(ISO_YM);
  if (iso) {
    const y = Number.parseInt(iso[1], 10);
    const m = Number.parseInt(iso[2], 10) - 1;
    const d = new Date(y, m, 1);
    if (!Number.isNaN(d.getTime())) return formatYearMonth(d, lang);
  }

  const slash = trimmed.match(SLASH_MY);
  if (slash) {
    const month = Number.parseInt(slash[1], 10) - 1;
    const year = Number.parseInt(slash[2], 10);
    const d = new Date(year, month, 1);
    if (!Number.isNaN(d.getTime())) return formatYearMonth(d, lang);
  }

  const wy = trimmed.match(WORD_THEN_YEAR);
  if (wy) {
    const parsed = new Date(`${wy[1]} 1, ${wy[2]}`);
    if (!Number.isNaN(parsed.getTime())) return formatYearMonth(parsed, lang);
  }

  const asDate = new Date(trimmed);
  if (!Number.isNaN(asDate.getTime())) return formatYearMonth(asDate, lang);

  return trimmed;
}
